var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.582 9c1.188-2.931 4.063-5 7.418-5 1.7 0 3.276.531 4.572 1.436.453.316.564.94.248 1.393-.316.452-.94.563-1.392.247-.972-.678-2.154-1.076-3.428-1.076-2.219 0-4.158 1.207-5.196 3h5.196c.552 0 1 .448 1 1s-.448 1-1 1h-5.917c-.055.325-.083.659-.083 1s.028.675.083 1h5.917c.552 0 1 .448 1 1s-.448 1-1 1h-5.196c1.038 1.793 2.977 3 5.196 3 1.274 0 2.456-.398 3.428-1.076.452-.316 1.076-.205 1.392.247.316.453.205 1.077-.248 1.393-1.296.905-2.872 1.436-4.572 1.436-3.355 0-6.23-2.069-7.418-5h-2.582c-.552 0-1-.448-1-1s.448-1 1-1h2.062c-.041-.328-.062-.661-.062-1s.021-.672.062-1h-2.062c-.552 0-1-.448-1-1s.448-1 1-1z",
    fill: "#F6C04B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.e06b7c4034361b1a2a86710497d51d52.svg";
export { ForwardRef as ReactComponent };